export { default } from '../components/pages/Home';
